<div class="whatsapp-button" *ngIf="whatsappLink">
    <a [href]="whatsappLink" target="_blank">
        <img src="../../assets/icons/fale-conosco.png" alt="WhatsApp" style="max-width: 30%; float: left !important;">
    </a>
</div>